// GENERATED from ez-tree preset "Aspen Large" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const AspenLarge_KIND_ID = "ezTree_AspenLarge";

export const AspenLargeKind = new SceneryKindDef({
	id: "ezTree_AspenLarge",
	name: "Aspen Large",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 2,
		"branchAngle1": 47,
		"branchAngle2": 63,
		"branchAngle3": 7,
		"branchChildren0": 10,
		"branchChildren1": 6,
		"branchChildren2": 0,
		"branchGnarliness0": 0.05,
		"branchGnarliness1": -0.030000000000000006,
		"branchGnarliness2": 0.12,
		"branchLength0": 69.60000000000001,
		"branchLength1": 18.56,
		"branchLength2": 11.19,
		"branchRadius0": 1.11,
		"branchRadius1": 0.5800000000000001,
		"branchStart1": 0.62,
		"branchStart2": 0.049999999999999975,
		"branchStart3": 0,
		"branchTaper0": 0.7000000000000001,
		"branchTaper1": 0.13,
		"leafCount": 20,
		"leafSize": 3.4782608695652173,
		"leafAngle": 36,
		"leafStart": 0.15217391304347827,
		"leafType": "aspen",
		"barkType": "Bark002",
		"forceStrength": 0.021739130434782622,
		"targetHeight": 25.72,
	},
	footprintRadiusRatio: 0.212,
});
